export const TERMS_OF_SERVICE_TEXT = `Opšti uslovi korišćenja
Ovim Opštim uslovima privredno društvo TeamCAD utvrđuje sadržaj i uslovi korišćenja web aplikacije PORTIR (u daljem tekstu: Aplikacija), te prava i obaveze Korisnika Aplikacije.

Termini i definicije
Vlasnik svih materijalnih autorskih prava na Aplikaciji je privredno društvo TeamCAD sa sedištem u Beogradu, ul. Šumadijska 47. Korisnik je pravno lice koje se na Aplikaciju prijavljuje sa svojom email adresom i lozinkom i prihvata ove Opšte uslove korišćenja Aplikacije.

Tehnički uslovi za korišćenje Aplikacije
Korisnik mora o svom trošku i na svoju odgovornost obezbediti sledeće tehničke uslove:

-trajno dostupan internet,

-softvere i hardvere za korišćenje interneta.

TeamCAD je u obavezi da Korisniku obezbedi ugovoren broj tagova, čitača tagova, prekidača i utičnica.

TeamCAD je vlasnik tagova, čitača tagova, prekidača i utičnica i Korisnik je u obavezi da nakon raskida ugovora istu opremu vrati o trošku TeamCAD-a.

Postupak registracije i zaključivanja ugovora
Korisnik je pre korišćenja Aplikacije dužan da prihvati Opšte uslove.

Pre prvog korišćenja Aplikacije, Korisnik je dužan da izvede postupak registracije kojom se identifikuje i prihvata Opšte uslove tako što će kvačicom označiti određeno polje/kvadratić, koji se nalazi ispred rečenice "Prihvatam Opšte uslove korišćenja web aplikacije portir.rs.".

Prihvatanjem Opštih uslova Korisnik se slaže i prihvata Opšte uslove koji važe uz svako korišćenje Aplikacije.

Trajanje ugovora, cene i uslovi plaćanja
Ugovor o korišćenju Aplikacije zaključuje se na neodređeno vreme.

Korisnik je za korišćenje određenog paketa Aplikacije dužan da plati mesečnu naknadu TeamCAD-u prema cenama objavljenim na sajtu portir.rs prvog dana u mesecu korišćenja Aplikacije za ukupan broj evidentiranih zaposlenih u mesecu korišćenja.

TeamCAD ispostavlja račun Korisniku prvog u mesecu za prethodni mesec, a Korisnik je dužan da plati ukupan iznos naveden u računu u roku od 8 dana od dana prijema računa.

Probno korišćenje
TeamCAD je ovlašćen da Korisniku bez naknade omogući probno korišćenje Aplikacije u trajanju od 30 dana.

TeamCAD može opozvati probno korišćenje Aplikacije u svakom trenutku, bez odobrenja Korisnika i bez odgovornosti za eventualnu štetu koja bi za Korisnika mogla nastati.

Za vreme perioda probnog korišćenja Aplikacije, Korisnik dobija 1 uređaj za čitanje kartica, 10 tagova ili 10 kartica i 1 pametnu utičnicu.

Nakon isteka perioda probnog korišćenja Aplikacije od 30 dana, Korisnik je dužan da obavesti TeamCAD da li nastavlja da koristi Aplikaciju uz plaćanje mesečne naknade ili odustaje od korišćenja Aplikacije.

U slučaju da Korisnik odustane od daljeg korišćenja Aplikacije obavezan je da vrati primljenu opremu o trošku TeamCAD-a.

Otkaz i raskid ugovora
TeamCAD i Korisnik mogu raskinuti ugovor, s tim što otkazni rok iznosi 30 dana. Pre raskida ugovora od strane Korisnika, Korisnik je dužan da prethodno izmiri sva dugovanja TeamCAD-u.

Tokom predviđenog roka plaćanja računa TeamCAD-a, Korisnik može koristiti Aplikaciju, a ako Korisnik ne izvrši uplatu u predviđenom roku, TeamCAD može raskinuti ugovor i deaktivirati lozinku.

Nakon naknadno primljene uplate, Korisniku se može ponovo aktivirati korišćenje Aplikacije.

Korisnička podrška
TeamCAD nudi podršku u vezi s radom portir.rs preko Korisničke podrške isključivo radnim danima od 8:30 sati do 16:30 sati na srpskom i engleskom jeziku.

Komunikacija između Korisnika i Korisničke podrške vrši se preko sistema "Zahtev za pomoć" u pisanoj formi.

TeamCAD se obavezuje da će ukloniti greške koje bi onemogućavale upotrebu Aplikacije.

Na svaku prijavljenu grešku TeamCAD će reagovati najkasnije u roku od 8 sati pri čemu se uzima u obzir radno vreme u kojem TeamCAD nudi Korisničku podršku.

Baza podataka i poverljivost informacija
Korisnik Aplikacije je vlasnik informacija u bazi podataka za zaposlene Korisnika i te informacije na zahtev Korisnik može dobiti od TeamCAD-a dok uredno plaća naknadu za korišćenje Aplikacije.

Podaci se sinhronizuju samo kada je dostupan pristup internet, u slučaju nedostupnosti internet, TeamCAD ne može omogućiti sinhronizaciju ili skladištenje podataka.

U slučaju prestanka ugovora o korišćenju Aplikacije, TeamCAD će omogućiti Korisniku pristup podacima na korisničkom nalogu u narednih 30 dana, tokom kojih će Korisnik moći da pristupi podacima, ali bez mogućnosti korišćenja Aplikacije.

Po proteku 30 dana od prestanka ugovora o korišćenju Aplikacije, podaci će biti izbrisani iz baze podataka, s tim da se podaci mogu izbrisati i pre isteka navedenog roka na pisani zahtev Korisnika.

Po isteku roka u kojem Korisnik može zatražiti isporuku baze podataka, TeamCAD nije dužan da čuva predmetne podatke, niti da ih stavi na raspolaganje Korisniku.

Korisnik se slaže da TeamCAD usluge može prikupljene podatke koji se na njega odnose, a koji se unose prilikom korišćenja Aplikacije, te ostale podatke potrebne za ispunjenje ugovora iznositi izvan Republike Srbije, u zemlje u kojima se nalaze podatkovni centri na kojima će biti instalirana Aplikacija.

Podatke o zaposlenima koje Korisnik prikuplja i unosi u Aplikaciju, TeamCAD nesme nikome dati na upotrebu, niti ih može obraditi u bilo koju drugu svrhu, osim u svrhu ispunjenja obaveza preuzetih ugovorom zaključenim sa Korisnikom.

TeamCAD je dužan da čuva u tajnosti sve podatke o kojima bi, u cilju ispunjenja svojih obaveza prema Korisniku u skladu sa Opštim uslovima, mogao dobiti informacije i obezbediće odgovarajuće mere zaštite podataka.

Isključenje odgovornosti TeamCAD-a
Korisnik koristi Aplikaciju kao autorsko delo, imajući u vidu sva njegova poznata svojstva i mogućnosti da sadrži skrivene nedostatke. TeamCAD ne odgovara za bilo kakvu štetu koja eventualno proizađe iz upotrebe, odnosno u vezi sa upotrebom Aplikacije, pa ni za štetu proizašlu iz evenutalnih skrivenih nedostataka Aplikacije, koji kao takvi nisu poznati TeamCAD-u.

Ukoliko se u toku trajanja ovog Ugovora pokaže neki skriveni nedostatak, Korisnik je dužan da o tom nedostatku bez odlaganja obavesti TeamCAD, a TeamCAD se obavezuje da u najkraćem roku otkloni navedeni nedostatak.

TeamCAD ne može biti odgovoran za bilo kakav gubitak podataka ili kakav drugi događaj do kog može doći zbog prekida internet veze za vreme korišćenja Aplikacije.

TeamCAD neće biti odgovoran Korisniku za štetu od neovlašćenog pristupa, neovlašćene izmene, neovlašćenog objavljivanja ili koje druge zloupotrebe.

Korisnik je dužan da se brine o sigurnosti lozinke. TeamCAD ne odgovara za slučajeve zloupotrebe korisničke lozinke, ali će odmah nakon što Korisnik prijavi zloupotrebu postupati kako bi zaštitio prava Korisnika.

Evidencija prisutnosti zaposlenih informativne je prirode i služi samo kao pomoć u vođenju evidencije o radnom vremenu zaposlenih u skladu sa pozitivnim propisima Republike Srbije.

Važenje i menjanje Opštih uslova i cena korišćenja
TeamCAD zadržava pravo naknadne izmene i/ili dopune Opštih uslova i cena korišćenja, o čemu Korisnika obaveštava objavom istih na veb stranici portir.rs.

Opšti uslovi i/ili Izmene Opštih uslova i cena korišćenja stupaju na snagu i primenjuju se danom objave za sve nove Korisnike, a za postojeće Korisnike se primenjuju od sledećeg meseca nakon objave.

Smatra se da je Korisnik pristao na izmene i/ili dopune Opštih uslova i cena korišćenja ako ne otkaže korišćenje Aplikacije u roku od 8 dana do dana objavljivanja izmene i/ili dopune Opštih uslova i cena korišćenja.

Nadležnost suda i merodavno pravo
Za sve eventualne sporove proizašle iz ugovora koje po ovim Opštim uslovima Korisnik zaključi sa TeamCAD-om merodavno je pravo Republike Srbije, a za rešavanje sporova nadležan je stvarno nadležan sud u Beogradu.`;

export const TERMS_ACCEPTANCE_LABEL = 'Prihvatam Opšte uslove korišćenja web aplikacije portir.rs.';
